<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="items"
            ref="RkmTable"
        >

            <template v-slot:cell(idadeInicial)="row">
                {{ row.item.idadeInicial }} {{ row.item.tipoIdade }}
            </template>

            <template v-slot:cell(idadeFinal)="row">
                {{ row.item.idadeFinal }} {{ row.item.tipoIdade }}
            </template>

            <template v-slot:cell(actions)="{ index, item }">
                <rkm-button
                    @click="$refs.Lista.open(index, item)"
                    :disabled="item.tipoResultadoId !== enums.tipoResultado.LISTA"
                    color="secondary"
                    authorize="update-parametrizacao-exame"
                    title="Cadastrar lista"
                    small
                >
                    <rkm-icon icon="list" />
                </rkm-button>

                <rkm-button
                    @click="$refs.Variavel.open(index, item)"
                    color="warning"
                    class="colorButton"
                    authorize="update-parametrizacao-exame"
                    title="Cadastrar variável"
                    small
                >
                    <rkm-icon icon="calculator" />
                </rkm-button>

                <rkm-button
                    @click="$refs.Modal.open(index, item)"
                    color="primary"
                    authorize="update-parametrizacao-exame"
                    title="Editar"
                    small
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    @click.stop="handleDestroy(item)"
                    color="danger"
                    authorize="destroy-parametrizacao-exame"
                    title="Excluir"
                    small
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="{form, model}"
            ref="Modal"
        />

        <Lista
            :data="{form, model}"
            ref="Lista"
        />

        <Variavel
            :data="{form, model}"
            ref="Variavel"
        />
    </div>
</template>

<script>

// Components.
import Modal from './Modal'
import Lista from './lista/Modal'
import Variavel from './variavel/Modal'

// Enums.
import tipoResultado from '@/enums/parametrizacao/composicaoTipoResultado'

export default {
    components: { Modal, Lista, Variavel },
    computed:{
        validations() {
            return {
                valor: {max: 8},
            }
        },
        fields() {
            return [
                { key: 'descricao', label: 'Descrição', sortable: true },
                { key: 'unidade', label: 'Unidade', sortable: true },
                { key: 'limiteInferior', label: 'Limite inferior mínimo', sortable: true },
                { key: 'limiteSuperior', label: 'Limite superior máximo', sortable: true },
                { key: 'tipoResultado', label: 'Tipo de resultado', sortable: true },
                { key: 'sexo', label: 'Sexo', sortable: true },
                { key: 'idadeInicial', label: 'Idade inicial', sortable: true },
                { key: 'idadeFinal', label: 'Idade final', sortable: true },
                { key: 'actions', label: 'Ações', class: 'col-min text-center' },
            ]
        },
        items() {

            return this.model.composicao
        },
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
    },
    data: () => ({
        filter: null,
        sexoId: null,
        enums: { tipoResultado },
    }),
    methods: {
        validate() {

            return this.$refs.Form.validate()
        },
        openModal() {

            this.$refs.Modal.open()
        },
        handleDestroy(item) {

            const objId = this.model.composicao.findIndex((obj => obj.id == item.id));

            const destroy = async () => this.model.composicao.splice(objId, 1)

            this.showDeleteConfirmation('Deseja realmente excluir a composição?', destroy)
        },
    },
}
</script>

<style scoped>
.colorButton {
    color: #fff;
}
</style>